module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTkiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxOSAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggaWQ9IlBvbHlnb24gOCIgZD0iTTkuNSAwTDE4LjU5MzMgMTUuNzVIMC40MDY3MzRMOS41IDBaIiBmaWxsPSIjMzlFNTkyIi8+Cjwvc3ZnPgo="


//////////////////
// WEBPACK FOOTER
// ./src/assets/community/value-up.svg
// module id = dx0C
// module chunks = 7